// Entry point. Finds the [data-cc-booking-widget] mount point on the host
// page and renders the widget into it.
//
// Embed contract: see ../../clubchampion-docs/architecture/widget-embedding-contract.md

import { createRoot } from 'react-dom/client';
import { Widget } from './widget';

const MOUNT_SELECTOR = '[data-cc-booking-widget]';

function init() {
  const mount = document.querySelector(MOUNT_SELECTOR);
  if (!mount) {
    console.warn(
      `[cc-widget] No mount point found. Add <div data-cc-booking-widget></div> to the page.`,
    );
    return;
  }

  if (mount.childNodes.length > 0) {
    console.warn('[cc-widget] Mount point already populated — refusing to re-mount.');
    return;
  }

  const embedSource = window.CC_WIDGET_CONFIG?.embedSource ?? 'unknown';
  const root = createRoot(mount);
  root.render(<Widget embedSource={embedSource} />);
}

// DOMContentLoaded is the fastest reliable signal that the mount point exists.
// If the script is loaded after the DOM is already ready, fire immediately.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
